export default __webpack_public_path__ + "static/media/img-intro.149e58cc.png";